// @flow

import * as React from 'react';
import classNames from 'classnames';
import Box from 'sail/Box';
import './Card.scss';

type CardProps = {|
  bordered?: boolean,
  className?: string,
  children: React.Node,
|};

export const Card = ({bordered = false, className, children}: CardProps) => (
  <Box
    className={classNames('Card', {'Card--bordered': bordered}, className)}
    flex={{direction: 'column'}}
  >
    {children}
  </Box>
);
